'use strict';
var ceil = Math.ceil;
var floor = Math.floor;

/**
 * 将数字的小数部分去掉，只保留整数部分
 * @param {number} x 任意数字
 */
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};
